import { useCallback, useEffect, useRef, useState } from 'react'

const GAP = 16

export function useCarousel<T extends HTMLElement>() {
  const trackRef = useRef<T>(null)
  const [activeIndex, setActiveIndex] = useState(0)

  const handleScroll = useCallback(() => {
    const track = trackRef.current
    if (!track) return
    const child = track.firstElementChild as HTMLElement | null
    if (!child) return
    setActiveIndex(Math.round(track.scrollLeft / (child.offsetWidth + GAP)))
  }, [])

  useEffect(() => {
    const track = trackRef.current
    if (!track) return
    track.addEventListener('scroll', handleScroll, { passive: true })
    return () => track.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  const scrollByCard = useCallback((direction: -1 | 1) => {
    const track = trackRef.current
    if (!track) return
    const child = track.firstElementChild as HTMLElement | null
    if (!child) return
    track.scrollBy({ left: direction * (child.offsetWidth + GAP), behavior: 'smooth' })
  }, [])

  return { trackRef, activeIndex, scrollByCard }
}
